import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-784450e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputError = _resolveComponent("InputError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      class: "input-base",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      modelValue: _ctx.formattedValue,
      ref: "inputRef"
    }), null, 16, _hoisted_1),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_InputError, { msg: _ctx.errors }, null, 8, ["msg"])
    ], 512), [
      [_vShow, _ctx.isInvalid]
    ])
  ]))
}